<template>
  <div class="examresult">
    <table-list
      title="考试阅卷"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="examList"
      :footer-btns="footerBtns(this)"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      :options="{ selection: true, operatesWidth: 300 }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <video-list-dialog ref="videoListDialog"></video-list-dialog>
    <set-marker-dialog ref="setMarkerDialog" @refresh="handleExamCheckPage"></set-marker-dialog>
  </div>
</template>
<script>
// 底部按钮
const footerBtns = _this => [
  {
    label: '导出全部',
    icon: 'el-icon-download',
    method: _this.exportTable,
  },
]
// 搜索框配置
const searchForm = _this => [
  {
    placeholder: '考试计划-考试科目',
    type: 'treeSelect',
    prop: 'examSubjectMaps',
    options: _this.examSubjectList,
    optionProps: {
      // value: 'id',
      // label: 'examPlanName',
      children: 'learnLevels',
      checkStrictly: true,
      lazy: true,
      lazyLoad: _this.treeLazyLoad,
    },
  },
  {
    label: '类型',
    type: 'select',
    prop: 'subjectType',
    children: [
      { value: '2', label: '理论' },
      { value: '1', label: '实操' },
    ],
  },
  {
    label: '职业',
    type: 'select',
    prop: 'jobId',
    children: _this.jobLevelList.map(item => ({
      value: item.id,
      label: item.jobName,
    })),
  },
  {
    label: '状态',
    type: 'select',
    prop: 'markStatus',
    children: [
      { value: false, label: '待阅卷' },
      { value: true, label: '已阅卷' },
    ],
  },
  {
    placeholder: '完成阅卷时间',
    type: 'picker',
    prop: 'time',
  },
  {
    label: '阅卷人',
    type: 'select',
    prop: 'markUserId',
    children: _this.adminList.map(item => ({
      value: item.key,
      label: item.value,
    })),
    defaultValue: parseInt(_this.markId),
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'examPlanName',
    label: '考试计划',
    twoLines: true,
    minWidth: 210,
  },
  {
    prop: 'examSubjectName',
    label: '科目名称',
    twoLines: true,
    minWidth: 210,
  },
  {
    prop: 'subjectTypeName',
    label: '类型',
    minWidth: 80,
  },
  {
    prop: 'jobLevel',
    label: '等级',
    minWidth: 90,
  },
  {
    prop: 'workTypeName',
    label: '工种',
    minWidth: 150,
  },
  {
    prop: 'jobName',
    label: '职业',
    minWidth: 180,
  },
  {
    prop: 'markSuccessCount',
    label: '完成阅卷人数',
    minWidth: 120,
  },
  {
    prop: 'examCount',
    label: '考试人数',
    minWidth: 80,
  },
  {
    prop: 'markStatusName',
    label: '状态',
    minWidth: 90,
  },
  {
    prop: 'markTime',
    label: '完成阅卷时间',
    sortdata: 1,
    minWidth: 170,
  },
  {
    prop: 'markUserNames',
    label: '阅卷人',
    minWidth: 110,
    twoLines: true,
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleSetMarker,
    label: '设置阅卷人',
    isShow: row => !row.markStatus && _this.isSuper,
  },
  {
    method: _this.handleCheckPaper,
    label: '考试阅卷',
  },
  {
    method: _this.handleVideoList,
    label: '阅卷视频',
  },
]
import TableList from '@/components/TableList'
import VideoListDialog from './components/VideoListDialog'
import SetMarkerDialog from './components/SetMarkerDialog'
import to from 'await-to'
import { startRecording } from '@/utils/screenRecord'
import {
  examresultPlanDropDown,
  examresultSubjectDropDown,
  filterJobLevel,
  filterAdminList,
  examMarkPage,
  examMarkExport,
} from '@/api/exam'
import { userIsSuper } from '@/api/login'
export default {
  name: 'ExamCheck',
  components: {
    TableList,
    VideoListDialog,
    SetMarkerDialog,
  },
  data() {
    return {
      searchForm,
      footerBtns,
      columns,
      operates,
      loading: false,
      examList: [],
      selectExamList: [],
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      queryParams: {},
      examSubjectList: [],
      jobLevelList: [],
      adminList: [],
      ruleType: Number,
      ruleName: Number,
      markId: this.$route.query.markUserId || '',
      isSuper: false,
    }
  },
  mounted() {
    this.handleIsSuper()
    this.getJobLevel()
    this.getAdminList()
    if (this.markId) {
      this.queryParams.markUserId = parseInt(this.markId)
    }
    this.handleExamCheckPage()
  },
  methods: {
    async treeLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      if (node.level == 0) {
        const [res, err] = await to(examresultPlanDropDown())
        if (err) return this.$message.warning(err.msg)
        const nodes = res.data.map(item => ({
          ...item,
          value: item.id,
          label: item.examPlanName,
        }))
        resolve(nodes)
      } else if (node.level == 1) {
        const [res, err] = await to(examresultSubjectDropDown({ planId: node.data.id }))
        if (err) return this.$message.warning(err.msg)
        const nodes = res.data.map(item => ({
          ...item,
          value: item.id,
          label: item.examSubjectName,
        }))
        resolve(nodes)
      } else {
        resolve()
      }
    },
    async getJobLevel() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.jobLevelList = res.data
    },
    async getAdminList() {
      const [res, err] = await to(filterAdminList({}))
      if (err) return this.$message.warning(err.msg)
      this.adminList = res.data
    },
    async handleIsSuper() {
      const [res, err] = await to(userIsSuper({}))
      if (err) return this.$message.warning(err.msg)
      this.isSuper = res.data
    },
    async handleExamCheckPage() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(examMarkPage({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.examList = res.data.list
      this.pager.total = res.data.total
    },
    // 查询按钮
    onSearch(queryParams) {
      if (queryParams.examSubjectMaps) {
        if (queryParams.examSubjectMaps.length == 0) {
          queryParams.planId = ''
          queryParams.subjectId = ''
        } else if (queryParams.examSubjectMaps.length == 1) {
          queryParams.planId = queryParams.examSubjectMaps[0]
          queryParams.subjectId = ''
        } else if (queryParams.examSubjectMaps.length == 2) {
          queryParams.planId = queryParams.examSubjectMaps[0]
          queryParams.subjectId = queryParams.examSubjectMaps[1]
        }
      } else {
        queryParams.planId = ''
        queryParams.subjectId = ''
      }
      if (queryParams.time && queryParams.time.length !== 0) {
        queryParams.markTimeBegin = queryParams.time[0]
        queryParams.markTimeEnd = queryParams.time[1].split(' ')[0] + ' 23:59:59'
      } else {
        queryParams.markTimeBegin = ''
        queryParams.markTimeEnd = ''
      }
      this.pager.current = 1
      this.queryParams = queryParams
      this.handleExamCheckPage()
    },
    //底部导出
    async exportTable() {
      let arr = []
      if (this.selectExamList.length) this.selectExamList.map(v => arr.push(v.id))
      const { current, size } = this.pager
      const [res, err] = await to(
        examMarkExport({
          current,
          size,
          ids: arr,
          ...this.queryParams,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '考试阅卷.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    //详情
    async handleCheckPaper(row) {
      // 点击「考试阅卷」开始对当前屏幕录制，用户取消授权时不阻断阅卷
      const [, recordErr] = await to(startRecording())
      if (recordErr) this.$message.warning('屏幕录制未开启：' + (recordErr.message || '用户取消'))
      this.$router.push({
        path: '/exam/mark/detail',
        query: { subjectId: row.id, paperId: row.paperId, planId: row.planId },
      })
    },
    // 阅卷视频列表
    handleVideoList(row) {
      this.$refs.videoListDialog.show(row)
    },
    // 设置阅卷人
    handleSetMarker(row) {
      this.$refs.setMarkerDialog.show(row)
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.handleExamCheckPage()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.handleExamCheckPage()
    },
    handleSelectionChange(val) {
      this.selectExamList = val
    },
  },
}
</script>
<style scoped lang="scss">
.examresult {
  ::v-deep .table-list {
    .form {
      .el-form-item .el-input {
        width: auto !important;
        .el-input__inner {
          width: 260px !important;
        }
      }
      .el-cascader .el-input,
      .el-select .el-input {
        width: auto !important;
        .el-input__inner {
          width: 220px !important;
        }
      }
      .el-date-editor {
        width: 250px !important;
      }
    }
  }
}
</style>
